/**
 * Abertura das janelas de compartilhamento das redes sociais.
 *
 * ATENÇÃO — DUAS DESTAS FUNÇÕES ESTÃO INATIVAS (2026-08-31)
 *
 * `shareOnFacebook` e `shareOnWhatsApp` **não têm chamador hoje**: os botões
 * correspondentes foram ocultados em `components/Postview.tsx` por decisão do
 * owner. Só `shareOnX` é importado de fato.
 *
 * O CÓDIGO DELAS ESTÁ CORRETO — o defeito não é aqui. Facebook e WhatsApp
 * montam a prévia do link buscando a URL **pelo servidor deles** e **não
 * executam JavaScript**. O app é um SPA (CRA) sem SSR nem prerender, e
 * `public/index.html` não tem NENHUMA meta tag Open Graph, então os dois
 * recebem o mesmo HTML sem tags para todo post: o Facebook abre o compositor
 * vazio e o WhatsApp mostra a URL crua. O X funciona justamente porque só cola
 * a URL como texto e não precisa ler a página — é a prova do diagnóstico.
 *
 * Foram MANTIDAS de propósito, em vez de apagadas, para que quem for resolver o
 * Open Graph não precise reescrever código idêntico e não conclua, pelo sumiço,
 * que o problema estava nelas.
 *
 * Para restaurar: reexibir os dois `<li>` no bloco de compartilhar de
 * `Postview.tsx` e reimportar as funções lá. A guarda em
 * `Postview.compartilhamento.test.tsx` (describe "Facebook e WhatsApp ocultos")
 * vai FALHAR de propósito nesse momento — é o lembrete de que o débito de Open
 * Graph precisa ter sido resolvido antes.
 *
 * Débito completo, com as opções de correção: `CLAUDE.md` da raiz,
 * "Compartilhamento em Facebook e WhatsApp sem prévia".
 */

/** INATIVA — sem chamador. Ver o bloco acima antes de reativar. */
export function shareOnFacebook(postUrl: string) {
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}`,
    '_blank',
    'noopener,noreferrer'
  );
}

/** ATIVA — é a única importada por `Postview.tsx`. */
export function shareOnX(postUrl: string) {
  window.open(
    `https://twitter.com/intent/tweet?url=${encodeURIComponent(postUrl)}`,
    '_blank',
    'noopener,noreferrer'
  );
}

/** INATIVA — sem chamador. Ver o bloco no topo antes de reativar. */
export function shareOnWhatsApp(postUrl: string) {
  window.open(
    `https://wa.me/?text=${encodeURIComponent(postUrl)}`,
    '_blank',
    'noopener,noreferrer'
  );
}
